import styled from 'styled-components';
import React, { FC, ReactElement } from 'react';
import useListingPageUrlState from '../../../hooks/ListingPage/useListingPageUrlState';
import useConfig from '../../../hooks/useConfig';
import AppliedFiltersSlider from './AppliedFiltersSlider';
import ClearAllFiltersButton from './ClearAllFiltersButton';

const StyledFiltersSliderWrapper = styled.div`
    margin-bottom: 20px;
`;

const AppliedFiltersSliderContainer: FC = (): ReactElement => {
    const [{ appliedFilters }, setListingPageStateFunc] = useListingPageUrlState();
    const { currency } = useConfig();

    const appliedFilterValues = appliedFilters
        .map(filter => filter.values)
        .reduce((allValues, values) => [...allValues, ...values], []);

    return appliedFilters.length === 0 ? (
        <span />
    ) : (
        <StyledFiltersSliderWrapper>
            <AppliedFiltersSlider
                appliedFiltersProps={appliedFilters}
                updateFilters={setListingPageStateFunc}
                currency={currency}
            />
            {appliedFilterValues.length >= 3 ? (
                <ClearAllFiltersButton updateFilters={setListingPageStateFunc} />
            ) : (
                <span />
            )}
        </StyledFiltersSliderWrapper>
    );
};

export default AppliedFiltersSliderContainer;
